// useBreakpoints.js
import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";

const useBreakpoints = () => {
  const theme = useTheme();

  const isXxs = useMediaQuery(('(max-width:450px)'));// >0px
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));// >0px
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));// >600px
  const isMd = useMediaQuery(theme.breakpoints.only("md"));// >900px
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));// >1200px
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));// >1536px

  return { isXxs, isXs, isSm, isMd, isLg, isXl };
};

export default useBreakpoints;
